import { Backdrop, Box, Chip, CircularProgress, ClickAwayListener, DialogActions, DialogContentText, FormLabel, Grid, IconButton, InputAdornment, makeStyles, Snackbar, TextField, Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import { createStyles, Theme, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import SearchIcon from "@material-ui/icons/Search";
import { Autocomplete, AutocompleteCloseReason } from '@material-ui/lab';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import Paper from '@mui/material/Paper';
import React, { useEffect, useState } from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import PuffLoader from 'react-spinners/PuffLoader';
import { Transition } from '../../components/GlobalStyles/DialogBoxTransition';
import { regexValidEmailForARM, url } from '../../constants/Constant';
import { AccessContext } from '../../models/accesscontrol/AccessContext';
import { IUserPermissions } from '../../models/accesscontrol/IUserPermissions';
import { WidgetMap } from '../../models/accesscontrol/WidgetMap';
import { IClientInfo } from '../../models/client/IClientInfo';
import { GlobalStateAction, useGlobalState } from '../../store/GlobalStore';
import { useFetch, usePost } from '../../utils/apiHelper';
import { DialogTitleDelete, DialogTitleHeader } from '../GlobalStyles/DialogStyle';
import { IUserInfo } from '../../models/accesscontrol/IUserInfo';

const useRowStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            '& > *': {
                borderBottom: 'unset',
                marginBottom: "0%",
                margin: theme.spacing(2),
                width: '25ch',
            },
        },
        formControl: {
            margin: theme.spacing(2),
            minWidth: 390,
            borderRadius: '10px',
            fontSize: 12,
            marginTop: '25px',
            fontWeight: 'bold',
            border: 'none',
        },
        close1: {
            float: 'right',
            marginTop: '0.8cm',
            marginBottom: '0.3cm',
            marginRight: '5px',
            borderRadius: '50px',
            fontSize: 12,
            backgroundColor: 'red',
            '&:hover': {
                backgroundColor: 'red',
            }
        },
        create: {
            float: 'right',
            marginTop: '0.8cm',
            marginRight: '15px',
            borderRadius: '50px',
            fontSize: 12,
            backgroundColor: 'green',
            "&:hover": {
                backgroundColor: 'green',
            }
        },
        backdrop: {
            zIndex: theme.zIndex.drawer + 1,
            color: '#fff',
        },
        GreenColor: {
            color: 'green',
        },
        paper1: {
            border: "2px solid black",
            fontSize: 13
        },
        titleheader: {
            fontWeight: 'bold',
            marginTop: '5px',
            color: 'white'
        },
        yesButton: {
            background: "red",
            color: 'white',
            borderRadius: 20,
            right: '15px',
            '&:hover': {
                background: "red",
            }
        },
        MessageStyle: {
            fontSize: '17px',
            marginTop: "15px",
            color: "black",
            fontWeight: 'bold'
        },
        TextBoxStyle: {
            minWidth: 390,
            backgroundColor: 'transparent',
            color: "white",
            height: 40,
            fontSize: 12,
            fontWeight: 'bold',
            borderRadius: '10px',
            border: 'none',
        },
        NameTextBoxStyle: {
            width: "41%",
            backgroundColor: 'transparent',
            color: "white",
            height: 40,
            fontSize: 12,
            fontWeight: 'bold',
            borderRadius: '10px',
            border: 'none',
        },
        outlinedInput: {
            fontSize: 14,
            color: "black",
            height: 40,
            border: 'none',
            '&$focused $notchedOutline': {
                color: 'white',
                border: 'none'
            },
        },
        outlinedInput1: {
            fontSize: 14,
            color: "black",
            border: 'none',
            '&$focused $notchedOutline': {
                color: 'white',
                border: 'none'
            },
        },
        noBorder: {
            border: "1px solid #215176",
            fontWeight: 'bold',
            borderBottom: "3px solid blue",
            fontSize: 14,
            '&:hover': {
                borderBottom: "3px solid blue",
            }
        },
        userbutton: {
            borderRadius: 20,
            fontSize: 11,
            marginTop: '5px',
            float: 'right'
        },
        titleheader1: {
            marginLeft: '2.3cm',
            fontSize: 17,
            marginTop: '20px'
        },
        titleHeader: {
            fontWeight: 'bold',
            marginTop: '5px',
            color: 'white',
            fontSize: 18,
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex'
        },
        checkBoxStyle: {
            backgroundColor: "light gray",
            height: "45px",
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
        },
        IconSizeStyle: {
            height: '20px',
            width: '20px'
        },
        textBoxStyle: {
            marginTop: '10px',
            fontSize: 10,
        },
        LabelBoxStyle: {
            marginLeft: '15px'
        },
        paper2: {
            border: '2px solid black',
            height: 'auto',
            margin: 0
        },
        clientCodeBox: {
            width: '390px',
            marginLeft: '15px',
            marginTop: '15px',
            borderRadius: '5px',
            '& .MuiOutlinedInput-root': {
                borderBottom: '3px solid blue',
                borderRadius: '5px'
            }
        },
        valueContainer: {
            "& > :not(:last-child)": {
                marginRight: '5px'
            },
            "& > *": {
                marginBottom: '5px'
            }
        },
        boxBorder: {
            border: '2px solid gray',
            marginLeft: '15px',
            padding: '2px 8px',
            borderRadius: '5px',
            maxWidth: '390px',
            marginTop: '5px',
            boxShadow: 'rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset'
        },
        textBoxStyle2: {
            fontSize: 10,
            '& .MuiChip-labelSmall': {
                fontSize: 10
            }
        },
        scrollMargin: {
            '& div:first-child': {
                marginBottom: '5px',
            },
            '& div:nth-child(3) div': {
                backgroundColor: '#2377e4 !important'
            },
            '& div:nth-child(3)': {
                top: '10px !important',
                bottom: '5px !important'
            },
        },
        CheckBoxBorder: {
            borderTop: '1px solid gray'
        },
        dialogePaper: {
            minWidth: "800px"
        },
        permission: {
            margin: 0,
            fontSize: 14,
        },
        buttonStyle: {
            borderRadius: '20px',
            backgroundColor: 'red',
            marginRight:'5%',
            color: 'white',
            '&:hover': {
                backgroundColor: 'red',
                color: 'white'
            }
        }
    })
);

const CreateUser: React.FC<{ onSave: () => void }> = (props) => {
    const { onSave } = props
    const { state, dispatch } = useGlobalState();
    const [open, setOpen] = React.useState(false);
    const [confirmedClients, setConfirmedClients] = React.useState([]);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    var newUser: AccessContext = new AccessContext();
    const [localState, setState] = React.useState(newUser);
    const classes = useRowStyles()
    const canCreateUser = state.userAccessContext?.createNewUsers;
    const [firstnameerror, setFirstNameError] = useState("");
    const [Lastnameerror, setLastNameError] = useState("");
    const [Emailerror, setEmailError] = useState("");
    const [isValid, setIsValid] = useState(false);
    const [isDisable, setIsDisable] = useState(false);
    const [isDisableFN, setIsDisableFN] = useState(false);
    const [isDisableLN, setIsDisableLN] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [ProgressBar, setShowProgressBar] = useState(false);
    const [selectedClients, setSelectedClients] = useState<any>([]);
    const [alertOpen, setAlertOpen] = useState(false);
    const [message, setMessage] = useState<string>('');
    const [checkAll, setCheckAll] = useState(false);
    const [ClientCodeOpen, setClientCodeOpen] = useState(false);
    const [searchClientCode, setSearchClientCode] = useState("");
    const [loading, setLoading] = useState(false);
    const [deselectClient, setDeselectClient] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [userDetails, SetUserDetails] = useState<any>();
    const [createOpen, setCreateOpen] = useState(false);

    const handleAlertClose = () => {
        setAlertOpen(false);
        setCheckAll(false);
    };

    const handleRemove = (event?: React.SyntheticEvent, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
        setIsValid(false);
    };

    function Alert(props: AlertProps) {
        return <MuiAlert elevation={6} variant="filled" {...props} />;
    }
    const resetValues = () => {
        localState.firstName = null;
        localState.lastName = null;
        localState.userName = null;
        localState.phone = null;
        setFirstNameError(null);
        setLastNameError(null);
        setEmailError(null);
        setSelectedClients([]);
        setSearchClientCode("");
    }

    const handleCreateClose = () => {
        setCreateOpen(false);
    }
    const handleClose = () => {
        setOpen(false);
        resetValues();
        setClientCodeOpen(false);
        setCheckAll(false);
        setEmailError(null);
    };

    useEffect(() => {
        if (localState.flatFeeAcRem === false
            && localState.acWaitingtoMove === false
            && localState.daysSincePlacmentofAc === false
            && localState.placementHistoryofMonthAc === false
            && localState.ageImpactofonAcResolution === false
            && localState.unReadNotifications === false) {
            setState({
                ...localState, flatFeeAcRem: true,
                daysSincePlacmentofAc: true,
                acWaitingtoMove: true,
                placementHistoryofMonthAc: true,
                ageImpactofonAcResolution: true,
                unReadNotifications: true
            });
        }
    }, [localState]);

    const handleDialogClose = () => {
        setDialogOpen(false);
    }

    const handleCreateUserOpen = () => {
        setOpen(false);
        setDialogOpen(true);
    }

    const handleInviteExistingUsers = (userId: any) => {
        (async () => {
            await useFetch<IUserInfo>("User/InviteADExsitingUser?userId=" + userId);
        })()
    }

    const handleValidateUserExisitInAD = () => {
        try {
            (async () => {
                try {
                    const response = await fetch("https://webview-api-uat.armsolutions.com/api/UserSignup/CheckEmailExist?userEmail=" + localState?.userName);
                    const data = await response.json();
                    if (data && data.length > 0) {
                        SetUserDetails(data);
                        handleCreateUserOpen();
                    } else {
                        setEmailError("This user does not exist in your organization, hence they can not be invited to WebView.");
                    }
                } catch (innerError) {
                    setEmailError("This user does not exist in your organization, hence they can not be invited to WebView.");
                }
            })().finally(() => {
            })
        } catch (error) {
            handleCreate();
        }
    }

    const handleCreate = () => {
        (async () => {
            setShowProgressBar(true);
            try {
                let selectedWidgets: number[] = [];
                for (let index = 1; index <= WidgetMap.size; index++) {
                    var value = WidgetMap.get(index);
                    if (value && localState[value]) {
                        selectedWidgets.push(index);
                    }
                }
                localState.clientCodes = selectedClients.map(r => r.client_Code);
                if (selectedClients.length <= 0) {
                    setIsValid(true);
                } else {
                    await usePost<{ userInfo: IUserPermissions, totalRecordCount: number }>("User/SaveUser", localState).then(async (r) => {
                        const data = {
                            'userId': r.data,
                            'widgets': selectedWidgets.join(',')
                        };
                        await usePost("User/AddWidgetsForClient", data).then((ClientsWidget) => {
                            setOpen(false);
                            setSnackbarOpen(true);
                            props.onSave();
                            resetValues();
                            setShowProgressBar(false);
                        });
                        userDetails ? handleInviteExistingUsers(r?.data) : null
                    }).catch((err) => {
                        if (err.response.status == 400) {
                            setAlertOpen(true);
                            setMessage(err.response.data);
                            dispatch({ type: GlobalStateAction.Error, error: err.statusText });
                            setShowProgressBar(false);
                        }
                    });
                    setShowProgressBar(false);
                }
            }
            catch (ex) {
                dispatch({ type: GlobalStateAction.Error, error: ex });
                dispatch({ type: GlobalStateAction.Idle });
            }
            finally {
                dispatch({ type: GlobalStateAction.Idle });
                setShowProgressBar(false);
                setDialogOpen(false);
            }
        })().finally(() => {
            setShowProgressBar(false);
            setShowProgressBar(false);
            setDialogOpen(false);
        })
    };

    const HandleFirstNameVal = (e) => {
        const FirstNameVal = e.target.value;
        if (!FirstNameVal.match(/[~!@#%^&*()-=+<>,.{};|?:[\]\\$'"]/)) {
            setFirstNameError("");
            setIsDisableFN(false);
        } else {
            setFirstNameError("please enter characters only");
            setIsDisableFN(true);
        }
    };

    const HandleLastNameVal = (e) => {
        const LastNameVal = e.target.value;
        if (!LastNameVal.match(/[~!@#%^&*()-=+<>,.{};|?:[\]\\$'"]/)) {
            setLastNameError("");
            setIsDisableLN(false);
        } else {
            setLastNameError("please enter characters only");
            setIsDisableLN(true);
        }
    };

    const validateEmail = (e) => {
        const email = e.target.value;
        if (regexValidEmailForARM.test(email)) {
            setEmailError("");
            setIsDisable(false);
        } else {
            setEmailError("please enter 'armsolutions.com' domain only");
            setIsDisable(true);
        }
    };

    const handleChange = (event) => {
        const name = event.target.name;
        setState({
            ...localState,
            [name]: event.target.value,
        });
    };

    const handleChecked = (event) => {
        const name = event.target.name;
        setState({
            ...localState,
            [name]: event.target.checked,
        });
    };

    const handleClientSelect = (event, selected) => {
        setSelectedClients(selected);
        if (selected?.length <= 0) {
            setCheckAll(false);
        }
    }

    const checkAllChange = (event) => {
        setCheckAll(event.target.checked);
        if (event.target.checked) {
            var NewClientList = confirmedClients.filter((c) => {
                return !selectedClients.find((r) => {
                    return c.client_Code == r.client_Code
                })
            });
            setSelectedClients([...new Set(selectedClients?.concat(NewClientList?.map((r) => r)))]);
            setClientCodeOpen(false);
        }
        setCheckAll(false);
        handleClear();
        setSearchClientCode("");
    };

    const DeselectAllChange = (event) => {
        setDeselectClient(event.target.checked);
        if (event.target.checked) {
            var NewClientList = selectedClients.filter((c) => {
                return !confirmedClients.find((r) => {
                    return c.client_Code == r.client_Code
                })
            });
            setSelectedClients(NewClientList);
            setClientCodeOpen(false);
        }
        setDeselectClient(false);
        handleClear();
        setSearchClientCode("");
    };

    const handleSearchClient = (e) => {
        setSearchClientCode(e.target.value);
    }

    const handleClear = () => {
        (async () => {
            setOpen(true);
            let request = {
                "userId": state?.userAccessContext?.id,
                "client_code": "",
                "isAdmin": false
            }
            await usePost<IClientInfo[]>("Client/searchClientCode", request).then((r) => {
                setConfirmedClients(r.data);
            }).finally(() => {
                setShowProgressBar(false);
            });
        })()
    };

    const handleClickAway = (e) => {
        (async () => {
            setClientCodeOpen(false);
            let request = {
                "userId": state?.userAccessContext?.id,
                "client_code": "",
                "isAdmin": false
            }
            await usePost<IClientInfo[]>("Client/searchClientCode", request).then((r) => {
                setConfirmedClients(r.data);
            }).finally(() => {
                setShowProgressBar(false);
            });
        })()
    };

    const onDelete = (clientcode) => () => {
        setSelectedClients((value) => value.filter((v) => v.client_Code !== clientcode));
    };

    return (
        <React.Fragment>
            <Dialog TransitionComponent={Transition}
                fullScreen={fullScreen} open={alertOpen} onClose={handleAlertClose} maxWidth={'sm'}
                aria-labelledby="responsive-dialog-title" PaperProps={{ style: { borderRadius: 10 } }} >
                <DialogTitleDelete id="responsive-dialog-title" onClose={handleAlertClose}>
                    <Typography variant="h6" gutterBottom className={classes.titleheader}>
                        CREATE USER
                    </Typography>
                </DialogTitleDelete>
                <DialogContent>
                    <DialogContentText>
                        <Typography variant="h6" className={classes.MessageStyle} gutterBottom>
                            {message}
                        </Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions >
                    <Button id="DU_ok_btn" variant="contained" onClick={(e) => { setAlertOpen(false); setOpen(true); }} className={classes.yesButton}>
                        Ok
                    </Button>
                </DialogActions>
            </Dialog>
            <Button id="CA_CreateUSer" size="small" variant="contained" startIcon={<PersonAddIcon />} color="primary" disabled={!canCreateUser} onClick={(e) => { setCreateOpen(true) }} className={classes.userbutton}>
                Create New User
            </Button>
            <Backdrop className={classes.backdrop} open={ProgressBar}>
                <PuffLoader size={80} color={"white"} speedMultiplier={1} />
            </Backdrop>
            <Dialog TransitionComponent={Transition}
                fullScreen={fullScreen}
                open={open}
                classes={{ paper: classes.dialogePaper }}
                PaperProps={{ style: { borderRadius: 15 } }}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
                fullWidth={true}
                style={{ zIndex: 1000 }}
            >
                <DialogTitleHeader id="responsive-dialog-title" onClose={handleClose}>
                    <Typography variant="h6" gutterBottom className={classes.titleheader}>
                        CREATE NEW USER
                    </Typography>
                </DialogTitleHeader>
                <DialogContent >
                    <Grid container>
                        <Grid item xs={7} >
                            <div>
                                <form className={classes.root} noValidate autoComplete="off" >
                                    <TextField id="CAU_FirstName"
                                        size="small" label="First Name"
                                        variant="outlined" name="firstName"
                                        onChange={(e) => { handleChange(e); HandleFirstNameVal(e); }}
                                        helperText={firstnameerror}
                                        error={!!firstnameerror}
                                        inputProps={{ maxlength: 25 }}
                                        InputProps={{
                                            classes: {
                                                root: classes.outlinedInput,
                                                notchedOutline: classes.noBorder
                                            }
                                        }}
                                        className={classes.NameTextBoxStyle} />
                                    <TextField id="CAU_LastName" size="small"
                                        label="Last Name" variant="outlined"
                                        name="lastName"
                                        onChange={(e) => { handleChange(e); HandleLastNameVal(e); }}
                                        helperText={Lastnameerror}
                                        error={!!Lastnameerror}
                                        inputProps={{ maxlength: 25 }}
                                        InputProps={{
                                            classes: {
                                                root: classes.outlinedInput,
                                                notchedOutline: classes.noBorder
                                            }
                                        }}
                                        className={classes.NameTextBoxStyle} />
                                </form>
                            </div>
                            <div>
                                <form className={classes.root} noValidate autoComplete="off" >
                                    <TextField id="CAU_Email" size="small" label="Email"
                                        variant="outlined" name="userName"
                                        type="email" onChange={(e) => { handleChange(e); validateEmail(e) }}
                                        helperText={Emailerror} error={!!Emailerror}
                                        InputProps={{
                                            classes: {
                                                root: classes.outlinedInput,
                                                notchedOutline: classes.noBorder
                                            }
                                        }}
                                        inputProps={{ maxlength: 50 }} className={classes.TextBoxStyle} />
                                </form>
                            </div>
                            <FormControl variant="outlined" size="small" className={classes.formControl} >
                                <InputLabel htmlFor="outlined-age-native-simple">Admin Level</InputLabel>
                                <Select native
                                    id="CAU_AdminLevel"
                                    onChange={handleChange}
                                    value={localState.role}
                                    label="Template"
                                    inputProps={{
                                        name: 'role',
                                        id: 'AdminLevel',
                                        classes: {
                                            root: classes.outlinedInput1,
                                            notchedOutline: classes.noBorder
                                        }
                                    }}
                                >
                                    <option value={0}>Regular User</option>
                                    <option value={1}>Client Admin</option>
                                </Select>
                            </FormControl>
                            <Box className={classes.LabelBoxStyle}>
                                <FormLabel style={{ fontWeight: 'bold', color: 'green' }}> Selected Client Code : {selectedClients?.length}</FormLabel>
                            </Box>
                            <div>
                                {!loading && selectedClients?.length > 0 ?
                                    <Paper className={classes.boxBorder}>
                                        <Scrollbars autoHide
                                            autoHideTimeout={1000}
                                            autoHideDuration={10}
                                            autoHeight
                                            className={`${classes.textBoxStyle2} ${classes.scrollMargin}`}
                                            autoHeightMin="auto"
                                            autoHeightMax={100}
                                            style={{ width: '365px' }}>
                                            <div className={`${classes.valueContainer}`}>
                                                {selectedClients.map((v) => (
                                                    <Chip key={v.client_Code} size="small" color="secondary" label={v.client_Code} onDelete={onDelete(v.client_Code)} />
                                                ))}
                                            </div>
                                        </Scrollbars>
                                    </Paper>
                                    :
                                    null
                                }
                                <ClickAwayListener onClickAway={handleClickAway}>
                                    <Box>
                                        <Autocomplete style={{ marginTop: '10px' }}
                                            multiple
                                            loading={loading}
                                            filterOptions={(options, state) => options}
                                            className={classes.clientCodeBox}
                                            autoComplete={false}
                                            id="checkboxes-tags-demo"
                                            options={confirmedClients}
                                            classes={{ paper: classes.paper2 }}
                                            disableClearable
                                            value={selectedClients}
                                            open={ClientCodeOpen}
                                            renderTags={() => null}
                                            onChange={(e, selected) => { handleClientSelect(e, selected); }}
                                            onOpen={() => {
                                                setClientCodeOpen(true);
                                            }}
                                            onClose={(e: any, reason: AutocompleteCloseReason) => {
                                                if (reason === "toggleInput") {
                                                    setClientCodeOpen(false);
                                                }
                                            }}
                                            getOptionDisabled={(option) => option.client_Code}
                                            getOptionLabel={(option) => option.client_Code}
                                            getOptionSelected={(option, value) => option.client_Code == value.client_Code}
                                            renderOption={(option, { selected }) => (
                                                <span className={`${selected ? classes.GreenColor : null}`} style={{ fontSize: 12, marginLeft: '8px' }}>
                                                    {`${option.client_Code} -- ${option.client_Name}`}
                                                </span>
                                            )}
                                            ListboxProps={
                                                {
                                                    style: {
                                                        maxHeight: '200px'
                                                    }
                                                }
                                            }
                                            renderInput={(params) => (
                                                <TextField {...params} fullWidth size="small"
                                                    value={searchClientCode} variant="outlined"
                                                    type='text' placeholder="Search Clients"
                                                    onChange={(e) => { handleSearchClient(e) }}
                                                    onKeyDown={event => {
                                                        if (event.key === 'Enter') { handleSearchClient(event); setClientCodeOpen(true); }
                                                    }}
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        endAdornment: (
                                                            <React.Fragment>
                                                                {loading ? <CircularProgress color="primary" size={20} /> : null}
                                                                {params.InputProps.endAdornment}
                                                                <InputAdornment position="end">
                                                                    <IconButton onClick={(_) => { setClientCodeOpen(true); }}>
                                                                        <SearchIcon className={classes.IconSizeStyle} />
                                                                    </IconButton>
                                                                </InputAdornment>
                                                                <Box display="flex" width="100%" className={classes.CheckBoxBorder}>
                                                                    <Box className={classes.checkBoxStyle} width="60%">
                                                                        <Checkbox size="small" disabled={loading || !confirmedClients.length}
                                                                            checked={checkAll}
                                                                            onChange={checkAllChange}
                                                                            id="check-all"
                                                                        />
                                                                        <span style={{ fontSize: 14 }}>Select All</span>
                                                                    </Box>
                                                                    <Box className={classes.checkBoxStyle} width="40%">
                                                                        <Checkbox size="small" disabled={loading || !confirmedClients.length}
                                                                            checked={deselectClient}
                                                                            onChange={(e) => { DeselectAllChange(e); }}
                                                                            id="check-all"
                                                                        />
                                                                        <span style={{ fontSize: 14 }}> Deselect All</span>
                                                                    </Box>
                                                                </Box>
                                                            </React.Fragment>
                                                        ),
                                                    }}
                                                    className={classes.textBoxStyle}
                                                />
                                            )}
                                        />
                                    </Box>
                                </ClickAwayListener>
                            </div>
                        </Grid>
                        <Grid item xs={5} >
                            <Typography variant="h6" gutterBottom className={classes.titleheader1}>{"PERMISSIONS"}</Typography>
                            <Box display="flex" alignItems="center" justifyContent="center">
                                <FormControl component="fieldset" >
                                    <FormGroup>
                                        <FormControlLabel
                                            id="CAU_paymentUpdates" className={classes.permission}
                                            control={<Checkbox onChange={handleChecked} name="paymentUpdates" size="small" />}
                                            labelPlacement="end"
                                            label="Payment Updates"
                                        />
                                        <FormControlLabel
                                            id="CAU_closingAccounts" className={classes.permission}
                                            control={<Checkbox onChange={handleChecked} name="closingAccounts" size="small" />}
                                            labelPlacement="end"
                                            label="Close Accounts"
                                        />
                                        <FormControlLabel
                                            id="CAU_rollAccounts" className={classes.permission}
                                            control={<Checkbox onChange={handleChecked} name="rollAccounts" size="small" />}
                                            labelPlacement="end"
                                            label="Roll Accounts"
                                        />
                                        <FormControlLabel
                                            id="CAU_placeAccounts" className={classes.permission}
                                            control={<Checkbox onChange={handleChecked} name="placeAccounts" size="small" />}
                                            labelPlacement="end"
                                            label="Place Accounts"
                                        />
                                        <FormControlLabel
                                            id="CAU_editReports" className={classes.permission}
                                            control={<Checkbox onChange={handleChecked} name="editReports" size="small" />}
                                            labelPlacement="end"
                                            label="Edit Reports"
                                        />
                                        <FormControlLabel
                                            id="CAU_createNewUsers" className={classes.permission}
                                            control={<Checkbox onChange={handleChecked} name="createNewUsers" size="small" />}
                                            labelPlacement="end"
                                            label="Create New Users"
                                        />
                                        <FormControlLabel
                                            id="CAU_uploadUnmappedFile" className={classes.permission}
                                            control={<Checkbox onChange={handleChecked} name="uploadUnmappedFile" size="small" />}
                                            labelPlacement="end"
                                            label="Upload Unmapped File"
                                        />
                                    </FormGroup>
                                </FormControl>
                            </Box>
                        </Grid>

                        <Grid item xs={12}>
                            <Button className={classes.close1} size="small" id="U_CU_Close_btn" onClick={handleClose} color="primary"
                                variant="contained" startIcon={<CancelIcon />}>
                                Close
                            </Button>
                            <Button className={classes.create} size="small" id="CAU_CreateNewUser" autoFocus
                                disabled={isDisable || isDisableFN || isDisableLN || (!localState.firstName || !localState.lastName || !localState.userName || !selectedClients?.length)} onClick={handleValidateUserExisitInAD}
                                color="primary" variant="contained" startIcon={<AccountCircleIcon />}>
                                Create User
                            </Button>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
            <Snackbar open={snackbarOpen} className="snackBarStyle" anchorOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }} autoHideDuration={4000} onClose={handleRemove}>
                <Alert onClose={handleRemove} severity="success" className="alertStyle">
                    User {localState.firstName}{localState.lastName} is Created Successfully !
                </Alert>
            </Snackbar>
            <Snackbar className="snackBarStyle" open={isValid} anchorOrigin={{
                vertical: 'top', horizontal: 'center'
            }} autoHideDuration={4000} onClose={handleRemove}>
                <Alert onClose={handleRemove} severity="error" className="alertStyle">
                    Please select atleast one client code.
                </Alert>
            </Snackbar>
            <Dialog open={dialogOpen} TransitionComponent={Transition} keepMounted
                onClose={handleDialogClose} aria-describedby="alert-dialog-slide-description" style={{ zIndex: 1100 }}
                PaperProps={{ style: { borderRadius: 15, maxHeight: 'calc(100% - 7px)' } }} >
                <DialogTitleDelete id="responsive-dialog-title" onClose={handleDialogClose}>
                    <Typography variant="h5" gutterBottom className={classes.titleHeader}>
                        CREATE AND INVITE AD USER
                    </Typography>
                </DialogTitleDelete>
                <DialogContent>
                    <Typography variant="h4" className={classes.MessageStyle} gutterBottom>
                        This user already exists in your organization. Would you like to invite them to WebView?
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button startIcon={<AccountCircleIcon />} size="small" style={{ borderRadius: '15px', backgroundColor: 'green', color: 'white' }} onClick={handleCreate}>Create User</Button>
                    <Button startIcon={<CancelIcon />} size="small" style={{ borderRadius: '20px', backgroundColor: 'red', color: 'white' }} onClick={handleDialogClose}>Cancel</Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={createOpen}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleCreateClose}
                maxWidth="md"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitleDelete id="responsive-dialog-title" onClose={handleCreateClose}>
                    <Typography variant="h5" gutterBottom className={classes.titleHeader}>
                        CREATE USER
                    </Typography>
                </DialogTitleDelete>
                <DialogContent>
                    <Typography variant="h4" className={classes.MessageStyle} gutterBottom>
                        WebView security has been improved, new users must now register with WebView. The new user can visit the WebView login screen <a href={url} target="_blank" rel="noopener">WebView</a> and click "Create New One". From there, the user will be able to securely register themselves as a WebView user.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button startIcon={<CancelIcon />} size="small" className={classes.buttonStyle} onClick={(e) => { setCreateOpen(false) }}>Close</Button>
                </DialogActions>
            </Dialog>
        </React.Fragment >
    );
}

export default CreateUser